export const TLCTemplateKey = 'tlc-template';
export const TLCTemplateActionTypeKey = 'tlc-template-action-type';
export const TlcTemplateDetailsKey = 'tlc-template-details';
